import { createCobrainerCustomizationProvider } from './cobrainer-customization-provider';

import type { CobrainerCustomizationProviderDependencies } from './cobrainer-customization-provider';
import type {
    CustomizationProvider,
    CustomizationProviderOptions,
} from '../../../shared/source/customization/customization';

export const createCustomizationProvider = (
    dependencies: Pick<CobrainerCustomizationProviderDependencies, 'validatingCobrainerApiFetcher'>,
    options: CustomizationProviderOptions,
): Promise<CustomizationProvider> =>
    createCobrainerCustomizationProvider(
        {
            storage: globalThis.localStorage,
            validatingCobrainerApiFetcher: dependencies.validatingCobrainerApiFetcher,
        },
        options,
    );
